// extracted by mini-css-extract-plugin
export default {"alert":"DownloadIdCardErrorAlert_alert__yNuFD","message":"DownloadIdCardErrorAlert_message__Wk1cR"};